import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MyForm from "@/pages/master/form/index";
import SubmitButtonWithLoader from "@/components/forms/SubmitButtonWithLoader";

const ModalWrapper = ({
  open,
  handleClose,
  formData,
  onSubmit,
  label,
  initialValues,
}) => {
  const theme = useTheme();
  const isUpdate = !!(initialValues && Object.keys(initialValues).length);

  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSubmit = async (values, formikHelpers) => {
    setIsSubmitting(true);
    try {
      await onSubmit(values, formikHelpers);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{ backgroundColor: theme.palette.primary.main, color: "#fff" }}
      >
        {label}
        <IconButton
          onClick={handleClose}
          sx={{ position: "absolute", right: 10, top: 8, color: "#fff" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <MyForm
          formData={formData}
          initialValues={initialValues}
          onSubmit={handleSubmit}
        />
      </DialogContent>

      <DialogActions>
        <SubmitButtonWithLoader
          onClick={handleClose}
          variant="outlined"
          disabled={isSubmitting}
        >
          Close
        </SubmitButtonWithLoader>
        <SubmitButtonWithLoader
          loading={isSubmitting}
          type="submit"
          form="dynamic-form"
          // sx={{
          //   backgroundColor: theme.palette.primary.lighter,
          //   color: theme.palette.primary.contrastText,
          //   "&:hover": {
          //     backgroundColor: theme.palette.primary.lighter,
          //   },
          // }}
        >
          {isUpdate ? "Update" : "Save"}
        </SubmitButtonWithLoader>
      </DialogActions>
    </Dialog>
  );
};

export default ModalWrapper;
